// // ProtectedRoute.js
// import React, { useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { Navigate, Outlet } from "react-router-dom";
// import { useVerifyTokenMutation } from "../slices/authSlice";
// import { logout } from "../slices/customerSlice";

// const ProtectedRoute = ({ children, redirectTo = "/login" }) => {
//   const { info } = useSelector((state) => state.frontendAuth);
//   const dispatch = useDispatch();
//   const [verifyToken] = useVerifyTokenMutation();

//   useEffect(() => {
//     const verifyAuthToken = async () => {
//       try {
//         await verifyToken().unwrap();
//       } catch (error) {
//         dispatch(logout());
//       }
//     };

//     if (info) {
//       verifyAuthToken();
//     }
//   }, [info, dispatch, verifyToken]);

//   if (!info) {
//     return <Navigate to={redirectTo} />;
//   }

//   return children ? children : <Outlet />;
// };

// export default ProtectedRoute;

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { useVerifyTokenMutation } from "../slices/authSlice";
import { logout } from "../slices/customerSlice";

// const ProtectedRoute = ({ children, redirectTo = "/login" }) => {
//   const { info } = useSelector((state) => state.frontendAuth); // Check if customer is logged in
//   const dispatch = useDispatch();
//   const [verifyToken] = useVerifyTokenMutation();

//   useEffect(() => {
//     const verifyAuthToken = async () => {
//       try {
//         const token = Cookies.get("_ag_cust"); // Retrieve token from cookies
//         if (token) {
//           await verifyToken({ token }).unwrap(); // Verify the token using backend
//         } else {
//           throw new Error("No token found");
//         }
//       } catch (error) {
//         dispatch(logout()); // Logout user if token verification fails
//       }
//     };

//     if (info) {
//       verifyAuthToken();
//     }
//   }, [info, dispatch, verifyToken]);

//   if (!info) {
//     return <Navigate to={redirectTo} />; // Redirect to login if not authenticated
//   }

//   return children ? children : <Outlet />;
// };
const ProtectedRoute = ({ children, redirectTo = "/login" }) => {
  const { info } = useSelector((state) => state.frontendAuth);
  const dispatch = useDispatch();
  const [verifyToken] = useVerifyTokenMutation();

  useEffect(() => {
    const verifyAuthToken = async () => {
      try {
        await verifyToken().unwrap(); // No need to manually retrieve the cookie
      } catch (error) {
        dispatch(logout());
      }
    };

    if (info) {
      verifyAuthToken();
    }
  }, [info, dispatch, verifyToken]);

  if (!info) {
    return <Navigate to={redirectTo} />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
